/**
 * @generated SignedSource<<c66916b46dec83444ccf1681eba93e73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SpecializationFieldsDialog_Query$variables = {
  industryId?: string | null | undefined;
};
export type SpecializationFieldsDialog_Query$data = {
  readonly industry: {
    readonly specializations?: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }> | null | undefined;
  } | null | undefined;
};
export type SpecializationFieldsDialog_Query = {
  response: SpecializationFieldsDialog_Query$data;
  variables: SpecializationFieldsDialog_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "industryId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "industryId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Specialization",
      "kind": "LinkedField",
      "name": "specializations",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Industry",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpecializationFieldsDialog_Query",
    "selections": [
      {
        "alias": "industry",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpecializationFieldsDialog_Query",
    "selections": [
      {
        "alias": "industry",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "optionalNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d21a7b2d19feaa571acfe431894f3fa1",
    "id": null,
    "metadata": {},
    "name": "SpecializationFieldsDialog_Query",
    "operationKind": "query",
    "text": "query SpecializationFieldsDialog_Query(\n  $industryId: ID\n) {\n  industry: optionalNode(id: $industryId) {\n    __typename\n    ... on Industry {\n      specializations {\n        id\n        name\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cfe35585793c9381dada4d85617c7b40";

export default node;
